import { render, staticRenderFns } from "./extrato-conciliacao.vue?vue&type=template&id=6355b5e5&"
import script from "./extrato-conciliacao.vue?vue&type=script&lang=js&"
export * from "./extrato-conciliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports